var map = {
	"./Codes.vue": [
		"c318",
		"chunk-0e1cad51",
		"chunk-2d21674d"
	],
	"./Datasets.vue": [
		"6835",
		"chunk-0e1cad51",
		"chunk-2d0d059a"
	],
	"./Event.vue": [
		"d3dc",
		"chunk-0f4367b6"
	],
	"./Home.vue": [
		"bb51",
		"chunk-599bdfac"
	],
	"./NotFound.vue": [
		"9703",
		"chunk-52a9f303"
	],
	"./Papers.vue": [
		"2a4a",
		"chunk-0e1cad51",
		"chunk-2d0bce52"
	],
	"./Researches.vue": [
		"6b63",
		"chunk-0e1cad51",
		"chunk-2d0da39f"
	],
	"./Resume.vue": [
		"1ba2",
		"chunk-2d0b62f8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;